import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-download",
  "use": "icon-download-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-download\">\n<path d=\"M8.00033 10.6666L4.66699 7.33329L5.60033 6.36663L7.33366 8.09996V2.66663H8.66699V8.09996L10.4003 6.36663L11.3337 7.33329L8.00033 10.6666ZM4.00033 13.3333C3.63366 13.3333 3.31977 13.2027 3.05866 12.9416C2.79755 12.6805 2.66699 12.3666 2.66699 12V9.99996H4.00033V12H12.0003V9.99996H13.3337V12C13.3337 12.3666 13.2031 12.6805 12.942 12.9416C12.6809 13.2027 12.367 13.3333 12.0003 13.3333H4.00033Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol